import { Autocomplete } from '@mui/material';
import styled from 'styled-components';

export default styled(Autocomplete)`
  .MuiOutlinedInput-root {
    padding: 6px !important;
  }
`;
